import * as types from '../../actions/actionTypes';

const initialState = {
  insuranceInfo: [],
  isLoading: false,
};

export default function reducer(state = initialState, action = '') {
  switch (action.type) {
    case types.SET_INSURANCE_INFO_PENDING: {
      return {
        ...state,
        isLoading: action.isLoading,
        insuranceInfo: null,
      };
    }
    case types.SET_INSURANCE_INFO_SUCCESS: {
      return {
        ...state,
        isLoading: action.isLoading,
        insuranceInfo: action.data,
      };
    }
    case types.SET_INSURANCE_INFO_ERROR: {
      return {
        ...state,
        isLoading: action.isLoading,
        error: action.error.message,
      };
    }
    case types.SET_REMOVE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: undefined,
        message: undefined,
      };
    }
    default:
      return state;
  }
}
